import { createAction } from 'redux-act';

import FacebookPage from '../../../../models/interfaces/FacebookPage';
import FetchPayload from '../../FetchPayload';
import TimestampPayload from '../../TimestampPayload';

export interface FetchFacebookPagePayload extends FetchPayload {
  placeUuid: string;
}
export const fetchFacebookPage = createAction<FetchFacebookPagePayload>('FETCH_FACEBOOK_PAGE');

export interface FacebookPageFetchedPayload extends TimestampPayload {
  placeUuid: string;
  facebookPage: FacebookPage | null;
}
export const facebookPageFetched = createAction<FacebookPageFetchedPayload>('FACEBOOK_PAGE_FETCHED');

export interface FacebookPageFetchFailedPayload extends TimestampPayload {
  placeUuid: string;
}
export const facebookPageFetchFailed = createAction<FacebookPageFetchFailedPayload>('FACEBOOK_PAGE_FETCH_FAILED');

export type FacebookPageFetchResponsePayload = FacebookPageFetchedPayload | FacebookPageFetchFailedPayload;
